export const convertToUTC = (value: string): Date => {
  return new Date(value + ' UTC');
};

export const convertUTCtoTimezone = (value: string, offset: string | number): Date => {
  const date = new Date(value);
  const timeZoneDate = date.setMinutes(date.getMinutes() + Number(offset));

  return new Date(timeZoneDate);
};

export const convertTimezoneToUTC = (value: string, offset: string): Date => {
  const utcDate = convertToUTC(value);
  const hoursOffset = Number(offset) / 60;
  const timeZoneDate = utcDate.setMinutes(utcDate.getHours() - hoursOffset);

  return new Date(timeZoneDate);
};

export const convertTimezoneToUTCISO = (value: Date, offset: string): string => {
  const currentDate = new Date(value);
  const hoursOffset = Number(offset) / 60;
  const timeZoneDate = currentDate.setHours(currentDate.getHours() - hoursOffset);
  const dateArray = new Date(timeZoneDate).toString().split(' ');

  dateArray[5] = 'GMT';
  dateArray.slice(0, 5);

  return new Date(dateArray.join(' ')).toISOString();
};
export const getHoursAndMinutes = (time: string): string => {
  return `${time.split(':')[0]} hr ${time.split(':')[1]} min`;
};
